// extracted by mini-css-extract-plugin
module.exports = {"groupAligner":"Builder_groupAligner__MYCAz","anchor":"Builder_anchor__hNesE"};